import { isMultiticketV1Shown } from '../../experimentation/experiments';
import type { checkoutDisqualifications } from '../../types/index';

export const shouldShowTicketsSection = (
    checkoutDisqualifications: checkoutDisqualifications,
) => {
    const isMultiticketExperimentActive = isMultiticketV1Shown();

    return (
        isMultiticketExperimentActive &&
        checkoutDisqualifications['more_than_one_ticket'] &&
        !checkoutDisqualifications['discount_code'] &&
        !checkoutDisqualifications['has_addons'] &&
        !checkoutDisqualifications['has_discounts'] &&
        !checkoutDisqualifications['has_donations'] &&
        !checkoutDisqualifications['has_inventory_tiers'] &&
        !checkoutDisqualifications['has_waiting_room'] &&
        !checkoutDisqualifications['has_waitlist'] &&
        !checkoutDisqualifications['is_canceled'] &&
        !checkoutDisqualifications['is_postponed'] &&
        !checkoutDisqualifications['is_rsvp'] &&
        !checkoutDisqualifications['is_sales_ended'] &&
        !checkoutDisqualifications['reserved_seating'] &&
        !checkoutDisqualifications['sold_out']
    );
};
